// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// A LIGAÇÃO AO MAPA — o que uma janela precisa para «levar o mapa lá» e dar nome aos dias
// ============================================================================
//
// 📗 Cliente, 2026-09-29: o Diário passa a mostrar os DIAS de cada registo e um «Ir para» por
//    linha. O Diário abre-se de CINCO sítios (o mapa, a barra de topo, o «o plano mudou», o
//    conflito ao gravar e o Detalhe de um pedido), e passar as duas propriedades por cada um
//    deles era a formulação que diverge: a abertura que ficasse esquecida mostrava «dia 247 do
//    ano» e um «Ir para» desactivado, sem nada o denunciar.
//
// ✅ **O `Mapa` fornece-a uma vez** (à volta de toda a sua árvore) e quem estiver lá dentro lê-a.
//    Uma propriedade passada à mão continua a ganhar — é o que as provas usam.
//
// ⚠️⚠️ **E o conflito ao gravar vive FORA dessa árvore** (monta-se na raiz, `App.tsx`). O `Mapa`
//    publica o mesmo valor por `publicarLigacao`, e o `App.tsx` fornece-o à volta do
//    `ConflitoAoGravar` — sem isto a quinta abertura ficava sem dias e sem «Ir para».
//
// ⚠️ **Fora do mapa o valor é `null`**, e isso é informação: quem a lê diz porque é que não pode
//    levar o mapa lá, em vez de fingir.
// ============================================================================

import { createContext } from 'react';

export interface LigacaoAoMapa {
  /** Leva o mapa à viatura e ao intervalo de dias (o `irPara` do `Mapa.tsx`). */
  readonly verNoMapa: (viaturaId: string, dia0: number, dia1: number) => void;
  /** O dia do ano em data curta, no ano do mapa (`dataCurtaDoDia`). */
  readonly nomeDoDia: (dia: number) => string;
  /**
   * 🔴 2026-10-30 · Pedido 1 · O id de um executor → o que o planeador lê: o número da frota (a
   * primeira coluna do mapa) ou o nome do subcontratado. Opcional: quem não o dá fica com o id.
   */
  readonly nomeDaViatura?: (id: string) => string;
}

export const LigacaoAoMapa = createContext<LigacaoAoMapa | null>(null);
